import type { ReactElement } from 'react'

interface StrengthStatImgProps {
  value: number | string
  size?: number
  fontFamily?: string
  fontWeight?: number
  fontSizeRatio?: number
  /** Numeral color override — see HeartStatImg. */
  color?: string
}

export const StrengthStatImg = ({
  value,
  size = 40,
  fontFamily = 'var(--pixel)',
  fontWeight = 400,
  fontSizeRatio = 0.56,
  color = '#fffaee',
}: StrengthStatImgProps): ReactElement => (
  <div
    style={{
      position: 'relative',
      width: size,
      height: size,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <img
      src="/glyph-assets/strength-icon.png"
      alt=""
      width={size}
      height={size}
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        filter: 'drop-shadow(0 2px 0 rgba(42,34,26,0.18))',
      }}
    />
    <span
      style={{
        position: 'relative',
        fontFamily,
        fontWeight,
        fontSize: Math.round(size * fontSizeRatio),
        color,
        textShadow:
          '0 0 0 #1a0e10, 1.5px 0 0 #1a0e10, -1.5px 0 0 #1a0e10, 0 1.5px 0 #1a0e10, 0 -1.5px 0 #1a0e10, 1.5px 1.5px 0 #1a0e10, -1.5px 1.5px 0 #1a0e10',
        lineHeight: 1,
        marginTop: Math.round(size * 0.12),
      }}
    >
      {value}
    </span>
  </div>
)
